module.exports = __webpack_public_path__ + "statics/img/FeaturedCases-5.b098f581.png";